const ROUTE_PATHS_BY_KEY = {
  home: "/",
  vehicles: "/gebrauchtwagen",
  offers: "/aktionen",
  "vehicle-search": "/gebrauchtwagen",
  models: "/modelle",
  "vehicle-purchase": "/fahrzeugankauf",
  service: "/serviceleistungen",
  "online-appointments": "/onlineterminvereinbarung",
  "workshop-appointment": "/werkstatttermin",
  "financial-services": "/finanzdienstleistungen",
  "audi-service": "/audi-service",
  camper: "/wiest-camper",
  "camper-service": "/wiest-camper/camper-nfz-service",
  mobility: "/elektromobilitaet",
  "electric-mobility": "/elektromobilitaet",
  fleet: "/grosskunden",
  "fleet-services": "/grosskunden/leistungen",
  "fleet-management": "/grosskunden/fuhrparkmanagement",
  "fleet-utilities": "/grosskunden/nuetzliches",
  wiestcars: "/grosskunden/wiestcars",
  about: "/ueber-uns",
  contacts: "/ansprechpartner",
  blog: "/beitraege",
  careers: "/karriere",
  history: "/geschichte",
  contact: "/oeffnungszeiten",
  imprint: "/impressum",
  privacy: "/datenschutz",
  accessibility: "/erklarung-zur-barrierefreiheit",
  "eu-garan": "/eu-garan",
  gender: "/gender-hinweis",
  partner: "/partner",
};

const GENERAL_EXTERNAL_REDIRECTS = {
  "/raederwechsel-id-logistics":
    "https://calendly.com/raderwechsel-id-logistics-qoy/raderwechsel-id-logistics?month=2024-04",
  "/angebote/dreems-moon-x": "https://www.wiest-dreems.de/product/moon-x",
  "/angebote/dreems-amalfi": "https://www.wiest-dreems.de/product/amalfi",
  "/angebote/dreems-amalfi-s": "https://www.wiest-dreems.de/product/amalfi-s",
};

const TENANT_EXTERNAL_REDIRECTS_BY_KEY = {
  "wiest-group": {
    "/karriere": "https://karriere.wiest-group.de/",
    "/karriere/ausbildung": "https://karriere.wiest-group.de/ausbildung/",
    "/karriere/ausbildung/automobilkaufmann--frau":
      "https://karriere.wiest-group.de/",
    "/karriere-alt": "https://karriere.wiest-group.de/",
    "/funnel/86c0x3h0d": "https://karriere.wiest-group.de/",
    "/funnel/86c0yeuyr": "https://karriere.wiest-group.de/",
  },
  "autohaus-rauch": {
    // No online booking at Rauch; relative target stays on the tenant host.
    "/onlineterminvereinbarung": "/werkstatttermin",
  },
  "schuetz-gross-umstadt": {},
};

const BASE_MENU_ITEM_DEFINITIONS = [
  {
    title: "Neu & Gebrauchtwagen",
    routeKey: "vehicles",
    children: [
      { title: "Aktionen & Angebote", routeKey: "offers" },
      { title: "Fahrzeugsuche", routeKey: "vehicle-search" },
      { title: "Neuwagensuche", href: "/gebrauchtwagen?condition=Neuwagen" },
      {
        title: "Gebrauchtwagensuche",
        href: "/gebrauchtwagen?condition=Gebrauchtwagen",
      },
      { title: "Kostenlose Fahrzeugbewertung", routeKey: "vehicle-purchase" },
    ],
  },
  {
    title: "Service",
    routeKey: "service",
    children: [
      { title: "Serviceleistungen", routeKey: "service" },
      {
        title: "Online-Terminvereinbarung",
        routeKey: "online-appointments",
        tenantLinkKey: "appointment",
      },
      { title: "Finanzdienstleistungen", routeKey: "financial-services" },
      { title: "Audi Service", routeKey: "audi-service" },
    ],
  },
  {
    title: "Camper",
    routeKey: "camper",
    children: [
      { title: "Wiest Camper", routeKey: "camper" },
      { title: "Camper Service", routeKey: "camper-service" },
      {
        title: "Camper Team",
        href: "/ansprechpartner?marke=Volkswagen+Nutzfahrzeuge&abteilung=Verkauf,Service&standort=Wiest+Darmstadt+Riedstra%C3%9Fe",
      },
      {
        title: "Shop",
        href: "https://shop.wiest-autohaeuser.de",
        external: true,
      },
    ],
  },
  {
    title: "Mobilität",
    routeKey: "mobility",
    children: [
      { title: "Elektromobilität", routeKey: "electric-mobility" },
    ],
  },
  {
    title: "Großkunden",
    routeKey: "fleet",
    trackedPaths: [
      "/grosskunden/*",
      "/ansprechpartner?abteilung=Gro%C3%9Fkunden",
      "/onlineterminvereinbarung",
    ],
    children: [
      {
        title: "Über uns",
        routeKey: "fleet",
      },
      {
        title: "Leistungsportfolio",
        routeKey: "fleet-services",
      },
      {
        title: "Fuhrparkmanagement",
        routeKey: "fleet-management",
      },
      {
        title: "Nützliches",
        routeKey: "fleet-utilities",
      },
      {
        title: "WiestCars",
        routeKey: "wiestcars",
      },
      {
        title: "Ansprechpartner",
        href: "/ansprechpartner?abteilung=Gro%C3%9Fkunden",
      },
      {
        title: "Onlineterminvereinbarung",
        routeKey: "online-appointments",
      },
    ],
  },
  {
    title: "Wiest Group",
    routeKey: "about",
    children: [
      { title: "Ansprechpartner", routeKey: "contacts" },
      { title: "Beiträge", routeKey: "blog" },
      {
        title: "Karriere",
        href: "/karriere",
        tenantLinkKey: "career",
      },
      {
        title: "Ausbildung",
        href: "/karriere/ausbildung",
        tenantLinkKey: "career-training",
      },
      { title: "Geschichte", routeKey: "history" },
    ],
  },
  {
    title: "Kontakt",
    routeKey: "contact",
    children: [
      { title: "Kontakt & Anfahrt", routeKey: "contact" },
      { title: "Öffnungszeiten", routeKey: "contact" },
      { title: "Ansprechpartner", routeKey: "contacts" },
    ],
  },
];

const BASE_FOOTER_MENU_SECTION_DEFINITIONS = [
  {
    id: "kontakt",
    title: "Kontakt",
    links: [
      { routeKey: "contact", title: "Kontakt & Anfahrt" },
      { routeKey: "contact", title: "Öffnungszeiten" },
      { routeKey: "contacts", title: "Ansprechpartner" },
    ],
  },
  {
    id: "fahrzeuge",
    title: "Neu- & Gebrauchtwagen",
    links: [
      { routeKey: "offers", title: "Angebote & Aktionen" },
      { routeKey: "vehicle-search", title: "Fahrzeugbestand" },
      { routeKey: "camper", title: "Camper" },
      { routeKey: "electric-mobility", title: "Elektromobilität" },
    ],
  },
  {
    id: "service",
    title: "Werkstatt & Service",
    links: [
      { routeKey: "service", title: "Service & Werkstattleistungen" },
      {
        routeKey: "online-appointments",
        title: "Online-Terminvereinbarung",
      },
    ],
  },
  {
    id: "unternehmen",
    title: "Wiest Group",
    links: [
      {
        href: "/karriere",
        title: "Karriere",
        tenantLinkKey: "career",
      },
      {
        href: "/karriere/ausbildung",
        title: "Ausbildung",
        tenantLinkKey: "career-training",
      },
      {
        routeKey: "blog",
        title: "Beiträge",
      },
    ],
  },
];

const TENANT_FOOTER_MENU_SECTION_DEFINITIONS_BY_KEY = {
  "schuetz-gross-umstadt": [
    {
      id: "kontakt",
      title: "Kontakt",
      links: [
        { routeKey: "contact", title: "Kontakt & Anfahrt" },
        { routeKey: "contact", title: "Öffnungszeiten" },
        { routeKey: "contacts", title: "Ansprechpartner" },
      ],
    },
    {
      id: "fahrzeuge",
      title: "Neu- & Gebrauchtwagen",
      links: [
        { routeKey: "offers", title: "Angebote & Aktionen" },
        { routeKey: "vehicle-search", title: "Fahrzeugbestand" },
        { routeKey: "electric-mobility", title: "E-Mobility Zentrum" },
      ],
    },
    {
      id: "service",
      title: "Werkstatt & Service",
      links: [
        { routeKey: "service", title: "Service & Werkstattleistungen" },
        {
          routeKey: "online-appointments",
          title: "Online-Terminvereinbarung",
        },
      ],
    },
    {
      id: "mobilitaetszentrum",
      title: "Mobilitätszentrum Groß-Umstadt",
      links: [
        {
          href: "/karriere",
          title: "Karriere",
          tenantLinkKey: "career",
        },
      ],
    },
  ],
  "autohaus-rauch": [
    {
      id: "kontakt",
      title: "Kontakt",
      links: [
        { routeKey: "contact", title: "Kontakt & Anfahrt" },
        { routeKey: "contacts", title: "Ansprechpartner" },
      ],
    },
    {
      id: "fahrzeuge",
      title: "Neu- & Gebrauchtwagen",
      links: [
        { routeKey: "offers", title: "Angebote & Aktionen" },
        { routeKey: "vehicle-search", title: "Fahrzeugbestand" },
        { routeKey: "electric-mobility", title: "E-Mobility Zentrum" },
      ],
    },
    {
      id: "service",
      title: "Werkstatt & Service",
      links: [{ routeKey: "service", title: "Service & Werkstattleistungen" }],
    },
    {
      id: "rauch-lampertheim",
      title: "Rauch Lampertheim",
      links: [
        {
          href: "/karriere",
          title: "Karriere",
          tenantLinkKey: "career",
        },
      ],
    },
  ],
};

const LEGAL_LINK_DEFINITIONS = [
  { routeKey: "imprint", title: "Impressum" },
  { routeKey: "privacy", title: "Datenschutz" },
  {
    routeKey: "accessibility",
    title: "Erklärung zur digitalen Barrierefreiheit",
  },
  { routeKey: "eu-garan", title: "EU-GARAN" },
  { routeKey: "gender", title: "Gender Hinweis" },
  { routeKey: "partner", title: "Partner" },
  { routeKey: "contact", title: "Kontakt" },
];

const TENANT_LEGAL_LINK_DEFINITIONS_BY_KEY = {};

const TENANT_SECTION_TEMPLATE_DEFINITIONS = {
  "autohaus-rauch": {
    submenuTemplate: [
      { title: "Startseite", routeKey: "home" },
      { title: "Kontakt", routeKey: "contact" },
      { title: "Angebote & Aktionen", routeKey: "offers" },
      { title: "Fahrzeugsuche", routeKey: "vehicle-search" },
      { title: "Serviceleistungen", routeKey: "service" },
      { title: "Ansprechpartner", routeKey: "contacts" },
      { title: "Beiträge", routeKey: "blog" },
      { title: "Karriere", routeKey: "careers" },
    ],
  },
  "schuetz-gross-umstadt": {
    submenuTemplate: [
      { title: "Startseite", routeKey: "home" },
      { title: "Kontakt", routeKey: "contact" },
      // Fahrzeuge
      { title: "Aktionen & Angebote", routeKey: "offers" },
      { title: "Fahrzeugsuche", routeKey: "vehicle-search" },
      {
        title: "Kostenlose Fahrzeugbewertung",
        routeKey: "vehicle-purchase",
      },
      // Service
      { title: "Serviceleistungen", routeKey: "service" },
      {
        title: "Onlineterminvergabe",
        routeKey: "online-appointments",
      },
      // Über uns
      { title: "Ansprechpartner", routeKey: "contacts" },
      { title: "News", href: "/news-aktuelles" },
      { title: "Karriere", routeKey: "careers" },
    ],
  },
};

const INTERNAL_REDIRECT_DEFINITIONS = [
  {
    source: "/angebote",
    destinationRouteKey: "offers",
  },
  {
    source: "/fahrzeuge",
    destinationRouteKey: "vehicles",
  },
  {
    source: "/modelle",
    destinationRouteKey: "home",
  },
  {
    source: "/termin",
    destinationRouteKey: "online-appointments",
  },
  {
    source: "/kontakt",
    destinationRouteKey: "contact",
  },
  {
    source: "/team",
    destinationRouteKey: "contacts",
  },
  {
    source: "/riese-mueller",
    destination: "/firmen/riese-mueller",
  },
  {
    source: "/unternehmen",
    destinationRouteKey: "about",
  },
  {
    source: "/mobilitaet",
    destinationRouteKey: "mobility",
  },
  {
    source: "/service",
    destinationRouteKey: "service",
  },
  {
    source: "/service-werkstatt",
    destinationRouteKey: "service",
  },
  {
    source: "/wiest-group-service",
    destinationRouteKey: "service",
  },
  {
    source: "/wiest-group-service/serviceleistungen",
    destinationRouteKey: "service",
  },
  {
    source: "/wiest-group-service/serviceleistungen/urlaubscheck",
    destination: "/serviceleistungen/urlaubscheck",
  },
  {
    source: "/camper",
    destinationRouteKey: "camper",
  },
  {
    source: "/wiest-camper/team",
    destination:
      "/ansprechpartner?marke=Volkswagen+Nutzfahrzeuge&abteilung=Verkauf,Service&standort=Wiest+Darmstadt+Riedstra%C3%9Fe",
  },
  {
    source: "/wiest-camper/kontakt",
    destinationRouteKey: "contact",
  },
  {
    source: "/wiest-camper/service",
    destinationRouteKey: "camper-service",
  },
  {
    source: "/wiest-camper/angebote",
    destination: "/gebrauchtwagen?vehicletype=camper",
  },
  {
    source: "/wiest-camper/gebrauchtwagen",
    destination: "/gebrauchtwagen?vehicletype=camper",
  },
  {
    source: "/wiest-camper/modelle",
    destinationRouteKey: "camper",
  },
  {
    source: "/wiest-camper/probefahrt",
    destinationRouteKey: "camper",
  },
  {
    source: "/wiest-camper/neuigkeiten",
    destinationRouteKey: "blog",
  },
  {
    source: "/angebote/dreems",
    destinationRouteKey: "home",
  },
  {
    source: "/aktionen/dreem-elektroroller",
    destinationRouteKey: "home",
  },
  {
    source: "/id-3-pro-aktion",
    destinationRouteKey: "home",
  },
  {
    source: "/angebote/d-3-pro-sonderleasing",
    destinationRouteKey: "home",
  },
  {
    source: "/aktionen/audi-original-e-scooter",
    destination: "/beitraege/audi-e-scooter",
  },
  {
    source: "/ranzenfete-darmstadt",
    destination: "/beitraege/einladung-zur-darmstadter-ranzenfete",
  },
  {
    source: "/beitraege/fruehlingserwachen",
    destination: "/beitraege/camper-festival",
  },
  {
    source: "/strassenumbauten",
    destination:
      "/beitraege/umleitung-einbahnstrassenring-neubau-rheinstrassenbrucke",
  },
  {
    source: "/help",
    destination: "/beitraege/help",
  },
  {
    source: "/erklarung-zur-digitalen-barrierefreiheit",
    destinationRouteKey: "accessibility",
  },
  {
    source: "/id-buzz",
    destination: "/gebrauchtwagen?make=Volkswagen&model=ID.+Buzz",
  },
  {
    source: "/angebote/id-buzz-pro-kr",
    destination: "/gebrauchtwagen?make=Volkswagen&model=ID.+Buzz",
  },
  {
    source: "/merck-mitarbeiterkonditionen",
    destination: "/firmen/merck",
  },
  {
    source: "/skoda",
    destination: "/skoda/aktionen",
  },
  {
    source: "/skoda/angebote",
    destination: "/skoda/aktionen",
  },
  {
    source: "/skoda/gebrauchtwagen",
    destination: "/gebrauchtwagen",
  },
  {
    source: "/audi",
    destination: "/audi/aktionen",
  },
  {
    source: "/audi/angebote",
    destination: "/audi/aktionen",
  },
  {
    source: "/audi/gebrauchtwagen",
    destination: "/gebrauchtwagen",
  },
];

const buildNextInternalRedirects = () =>
  INTERNAL_REDIRECT_DEFINITIONS.map((redirect) => ({
    source: redirect.source,
    destination:
      redirect.destination ??
      ROUTE_PATHS_BY_KEY[redirect.destinationRouteKey] ??
      "/",
    permanent: true,
  }));

module.exports = {
  ROUTE_PATHS_BY_KEY,
  GENERAL_EXTERNAL_REDIRECTS,
  TENANT_EXTERNAL_REDIRECTS_BY_KEY,
  BASE_MENU_ITEM_DEFINITIONS,
  BASE_FOOTER_MENU_SECTION_DEFINITIONS,
  TENANT_FOOTER_MENU_SECTION_DEFINITIONS_BY_KEY,
  LEGAL_LINK_DEFINITIONS,
  TENANT_LEGAL_LINK_DEFINITIONS_BY_KEY,
  TENANT_SECTION_TEMPLATE_DEFINITIONS,
  INTERNAL_REDIRECT_DEFINITIONS,
  buildNextInternalRedirects,
};
